export default class {
  constructor (symptomChecking) {
    this.organName = symptomChecking.organName
    this.organType = symptomChecking.organType
    this.isNormal = symptomChecking.isNormal
    this.symptomDetail = symptomChecking.symptomDetail
  }
}
